
import { Observable, Subject } from 'rxjs';
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import { ENVIRONMENT } from '../../environments/environment';
import CONFIGURATION from '../../configurations/configuration';

import { BaseService } from '../services/base.service';
import { AuthService } from './auth.service';
import { NotificationService } from './notification.service';

import { EventEmitter } from '../models/generic.class';
import { Rating } from '../models/feedback.class';


@Injectable()
export class UserService {
  userLoginServiceEventEmitter: Subject<any>;
  userOnLoginServiceEventEmitter: EventEmitter;
  FUSIONAUTH_SETTING = ENVIRONMENT.fusionAuth;
  constructor(
    private _http: HttpClient,
    private _authService: AuthService,
    private _baseService: BaseService,
    private _notificationService: NotificationService,
    private _localStorageService: LocalStorageService,
  ) {
    this.userLoginServiceEventEmitter = new Subject();
    this.userOnLoginServiceEventEmitter = new EventEmitter();
  }

  // Cryptography
  getPublicKey(): Observable<any> {
    let url = ENVIRONMENT.service.v2 + '/security/public_key';
    return this._baseService.get(url);
  }

  logIn(userName: string, password: string, uuid: string, otpChannel?: string): Observable<any> {
    let url = ENVIRONMENT.service.authentication + '/mobile_login/oauth/token';
    const formData = new FormData();
    let params = new HttpParams();
    formData.append('client_id', 'x_mobile_api_client');
    formData.append('country_id', CONFIGURATION.country_code);
    formData.append('grant_type', 'password');
    formData.append('password', password);
    formData.append('scope', 'read');
    formData.append('username', userName);
    formData.append('uuid', uuid);
    params = params.set('auth_type', '2fa');
    params = params.set('biometric_login_enabled', 'false');
    if (otpChannel) {
      params = params.set('otp_channel', otpChannel);
    }
    url = this._baseService.getUrlWithParams(url, params);
    return this._http.post(url, formData);
  }

  logInWithOtp(userName: string, uuid: string, refreshToken: string, otp: string): Observable<any> {
    let url = ENVIRONMENT.service.authentication + '/mobile_login/oauth/token';
    const formData = new FormData();
    let params = new HttpParams();
    formData.append('client_id', 'x_mobile_api_client');
    formData.append('country_id', CONFIGURATION.country_code);
    formData.append('grant_type', 'refresh_token');
    formData.append('scope', 'read');
    formData.append('username', userName);
    formData.append('uuid', uuid);
    formData.append('refresh_token', refreshToken);
    formData.append('2fa', otp);
    params = params.set('auth_type', '2fa');
    // For mobile backward compatibility
    params = params.set('biometric_login_enabled', 'false');
    url = this._baseService.getUrlWithParams(url, params);
    return this._http.post(url, formData);
  }

  refreshLogIn(refreshToken: string): Observable<any> {
    let url = ENVIRONMENT.service.authentication + '/mobile_login/oauth/token';
    let formData = new FormData();
    formData.append('client_id', 'x_mobile_api_client');
    formData.append('country_id', CONFIGURATION.country_code);
    formData.append('grant_type', 'refresh_token');
    formData.append('refresh_token', refreshToken);
    formData.append('scope', 'read');
    return this._http.post(url, formData);
  }

  logOut(): Observable<any> {
    let url = ENVIRONMENT.service.authentication + '/mobile_login/user/logout';
    return this._baseService.post(url, null);
  }

  saveQuestionnaires(feedbacks: Array<any>) {
    const url = ENVIRONMENT.service.authentication + '/questionnaires';
    return this._baseService.post(url, { feedbacks: feedbacks });
  }

  sendFeedback(authenticated: boolean, ratings: Array<Rating>, comments: string, country: string, email: string = null) {
    const url = `${ENVIRONMENT.service.v2}/users/send-feedback${authenticated ? '' : '/logout'}`;
    const payload = {
      comments,
      country,
      email,
      ratings,
    };
    return this._baseService.post(url, payload);
  }
}
